module.exports = "/packs/images/home/video-poster-e53f86d67d606f4568607e2be5784b28.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/home/video-poster.jpg
// module id = 1648
// module chunks = 0